import { DefaultLogger } from "../logger";
import { FileObject, PathType, ResolvedFile } from "@citychallenge/common";

/*
 FileResolve class is responsible for resolving bundle and remote URL's
 to a React Native usable file format
 */
export class FileResolver {
  private _resourcesPath?: string;
  constructor(_resourcesPath?: string) {
    this._resourcesPath = _resourcesPath;
  }

  public get resourcesPath(): string | undefined {
    return this._resourcesPath;
  }

  private _resolveRemoteUri(uri: string) {
    return {
      uri,
    };
  }

  private _resolveResourceUri(filePath: string) {
    return {
      uri: `file://${this.resourcesPath}/${filePath}`,
    };
  }

  public isRemoteFile(fileObject: FileObject) {
    return fileObject.pathType === PathType.remote;
  }

  public isResourceFile(fileObject: FileObject) {
    return fileObject.pathType === PathType.resource;
  }

  /*
  Resolve URI
  If it uses remote: prefix just pass back a remote http URI,
  if it uses the bundle: prefix we pass back a local file:// uri
  */
  public resolve(fileObject?: FileObject): ResolvedFile {
    if (!fileObject) {
      return {
        uri: undefined,
      };
    }
    if (this.isResourceFile(fileObject)) {
      return this._resolveResourceUri(fileObject.path);
    } else if (this.isRemoteFile(fileObject)) {
      return this._resolveRemoteUri(fileObject.path);
    } else {
      DefaultLogger.captureException(
        new Error(
          `Received path ${fileObject.path} with type ${fileObject.pathType} which cannot be correctly resolved.`
        )
      );
      return {
        uri: fileObject.path,
      };
    }
  }
}
